import type { AxiosInstance, AxiosProgressEvent } from "axios";
import { API_URL, APPLET_URL, DATA_URL, UPLOAD_URL } from "~/env";
import type { FetchEventSourceConfig } from "~/utils/axios-utils";
import { downloadPOST, sendRequest, sendSSERequest } from "~/utils/axios-utils";

const url = {
  getSessionList: "/ai/api/v1/gptIm/listSession",
  removeSession: "/ai/api/v1/gptIm/delSession",
  registerTIM: "/ai/api/v1/gptIm/userRegister",
  uploadFileIm: "/ai/api/file/uploadFileIm",
  uploadFileGpt: "/ai/api/v1/gptIm/uploadFileToGpt",
  fileUploadTempUrl: `${UPLOAD_URL}/ai/api/file/fileSecretUploadUrl`,
  uploadFileToGptV2: "/ai/api/v1/gptIm/uploadFileToGptV2",
  uploadFileToGptNew: "/ai/api/v1/gptIm/confirmUploadMultiFile",
  uploadFileToGptV3: "/ai/api/v1/gptIm/uploadFileToGptV3",
  getDirectiveList: "/ai/api/v1/gptIm/instructs",
  getContractHistoryList: "/ai/api/v1/gptIm/selectGptChatHistory",
  getSessionChatHistoryList: "/ai/api/v1/gptIm/selectGptChatHistoryV3",
  getRelatedCaseList: "/ai/api/v1/gptIm/relatedCase",
  getFileRelatedCaseList: "/ai/api/v1/gptIm/fileRelatedCase",
  submitFeedback: "/ai/api/v1/gptIm/feedbackMsg",
  getLimitUser: "/ai/api/v1/gptIm/getLimitUser",
  sendGptMessage: "/ai/api/v1/gptIm/sendGptMessage",
  sendGptMessageStream: "/ai/api/v1/gptIm/sendGptMessageStream",
  sendGptMessageStreamV4: "/ai/api/v1/gptIm/sendGptMessageStreamV4",
  sendGptMessageStreamV4Enterprise: "/ai/api/v1/enterprise/sendGptMessageStreamV4", //企业版
  sendGptMessageFileInstructStream: "/ai/api/v1/gptIm/sendGptMessageFileInstructStream",
  sendMultiFileStream: "/ai/api/v1/gptIm/sendMultiFileStream",
  sendMultiFileStreamV2: "/ai/api/v1/gptIm/sendMultiFileStreamV2",
  sendMultiFileStreamV2AI: "/ai/api/v1/gptIm/sendMultiFileStreamV2AI", // 文书AI专用接口
  sendGptMessageInstructStream: "/ai/api/v1/gptIm/sendGptMessageInstructStream",
  sendGptMessageFileStream: "/ai/api/v1/gptIm/sendGptMessageFileStream",
  subscriptionGlobal: "/ai/api/v1/gptIm/sse",
  createSession: "/ai/api/v1/gptIm/createSession",
  topSession: "/ai/api/v1/gptIm/toppingSession",
  getLawyerAndInsert: "/ai/api/v1/gptIm/screenLawyerAndInsert",
  getLawyerInfo: "/ai/api/v1/gptIm/lawyerInfo",
  submitConsultLawyer: "/ai/api/v1/gptIm/consultingLawyer",
  updateSessionRecord: "/ai/api/v1/gptIm/updateSession",
  getSearchSuggestData: "/ai/api/v1/gptIm/suggest",
  createShareData: "/ai/api/v1/gptIm/generateSharingV3",
  getShareRecordListV0: "/ai/api/v1/gptIm/getSharing",
  getShareRecordList: "/ai/api/v1/gptIm/getSharingV3",
  getShortUrlCode: "/ai/api/v1/gptIm/gentShortUrlCode",
  createDirective: "/ai/api/v1/gptIm/createInstructsSession",
  getDirectiveChatHistoryList: "/ai/api/v1/gptIm/selectGptChatHistoryInstruct",
  getPromptType: "/ai/api/v1/gptIm/selectCategory",
  batchDelete: "/ai/api/v1/gptIm/delSessionBatch",
  getPrompt: "/ai/api/v1/gptIm/selectPrompt",
  createFileSession: "/ai/api/v1/gptIm/createFileSession",
  deleteFileSession: "/ai/api/v1/gptIm/delFileSession",
  selectMultiFileHistory: "/ai/api/v1/gptIm/selectMultiFileHistory",
  selectMultiFileHistoryV2: "/ai/api/v1/gptIm/selectMultiFileHistoryV2",
  topFileSession: "/ai/api/v1/gptIm/filePin",
  editFileSession: "/ai/api/v1/gptIm/editFileSession",
  getFileSessionList: "/ai/api/v1/gptIm/selectFileSession",
  saveFile: "/ai/api/v1/gptIm/saveFile",
  uploadMultiFile: "/ai/api/v1/gptIm/uploadMultiFile",
  uploadMultiFileV2: "/ai/api/v1/gptIm/uploadMultiFileV2",
  delMultiFileRecord: "ai/api/v1/gptIm/delMultiFileRecord",
  confirmUploadMultiFile: "/ai/api/v1/gptIm/confirmUploadMultiFile",
  getFileSharing: "/ai/api/v1/gptIm/sharingFile",
  screenLawyer: "/ai/api/v1/gptIm/screenLawyer",
  createStudySession: "/ai/api/v1/gptIm/studyCreateSession",
  getStudySessionList: "/ai/api/v1/gptIm/studyListSession",
  sendGptMessageStreamSummaryAi: "/ai/api/v1/gptIm/studyStreamSummaryV2",
  sendGptMessageStudyStreamAnalysis: "/ai/api/v1/gptIm/studyStreamAnalysisV3",
  sendGptMessageStudyAnalysisStreamNew: "/ai/api/v1/gptIm/studyStreamAnalysisV4",
  studySseInterrupt: "/ai/api/v1/gptIm/studySseInterrupt",
  selectStudyGptChatHistory: "/ai/api/v1/gptIm/selectStudyGptChatHistoryV3",
  getStudySharing: "/ai/api/v1/gptIm/getStudySharing",
  sendStudyRhetoricalQuestionStream: "/ai/api/v1/gptIm/sendStudyRhetoricalQuestionStream",
  exportFile: "/ai/api/v1/gptIm/downloadQaFile",
  downloadContractAnswer: "/ai/api/v1/gptIm/downloadContractAnswer",
  createContractSession: "/ai/api/v1/gptIm/createContractSession",
  deleteContractSession: "/ai/api/v1/gptIm/delContractSession",
  getContractSessionList: "/ai/api/v1/gptIm/selectContractSession",
  filePinContract: "/ai/api/v1/gptIm/contractSessionPin",
  sendGptMessageContractStream: "/ai/api/v1/gptIm/sendGptMessageContractStream",
  sendGptMessageContractStreamEnterprise: "/ai/api/v1/enterprise/sendGptMessageContractStream", //企业版
  updateContractSession: "/ai/api/v1/gptIm/updateContractSession",
  selectNewSession: "/ai/api/v1/gptIm/selectNewSession",
  contractReviewListSession: "/ai/api/v1/gptIm/contractReviewListSession",
  contractReviewHistory: "/ai/api/v1/gptIm/contractReviewHistory",
  reviewCreateSession: "/ai/api/v1/gptIm/contractReviewCreateSession ",
  reviewFileUpload: "/ai/api/v1/gptIm/contractReviewFileUpload",
  contractReview: "/ai/api/v1/gptIm/contractReview",
  reviewFilePreview: "/ai/api/v1/gptIm/contractReviewFilePreview",
  reviewRefreshToken: "/ai/api/file/refreshToken/",
  downloadContractReview: "/ai/api/file/download/1/",
  downloadContractReviewRevised: "/ai/api/v1/gptIm/downloadContractReviewFile",
  queryInternalBetaPassStatus: "/api/v1/internal/beta/queryInternalBetaPassStatus",
  revisionRisk: "/ai/api/v1/gptIm/revisionRisk",
  removeRisk: "/ai/api/v1/gptIm/removeRisk",
  updateAiSuggest: "/ai/api/v1/gptIm/updateAiSuggest",
  contractReviewCount: "/ai/api/v1/gptIm/contractReviewCount",
  contractReviewExample: "/ai/api/v1/gptIm/contractReviewExample",
  contractReviewSse: "/ai/api/v1/gptIm/contractReviewSse",
  contractReviewSseEnterprise: "/ai/api/v1/enterprise/contractReviewSse", //企业版
  contractReviewTypes: "/ai/api/v1/gptIm/contractReviewTypes",
  contractAbstract: "/ai/api/v1/gptIm/contractAbstract",
  contractAbstractHistory: "/ai/api/v1/gptIm/contractAbstractHistory",
  sendGptMessageSIQ: "/ai/api/v1/gptIm/sendGptMessageSIQ",
  screenLawyerSIQ: "/ai/api/v1/gptIm/screenLawyerSIQ",
  screenLawyerAndInsertSIQ: "/ai/api/v1/gptIm/screenLawyerAndInsertSIQ",
  lawyerInfoSIQ: "/ai/api/v1/gptIm/lawyerInfoSIQ",
  saveLeaveMessageSIQ: "/ai/api/v1/lawyer_leave_message/saveLeaveMessageSIQ",
  queryToken: "/api/v1/digital/queryToken",
  fileSecretDownloadUrl: `${UPLOAD_URL}/ai/api/file/fileSecretDownload`,
  downloadAnalyse: "/ai/api/v1/gptIm/fileAnalyzeDownload",
  getFileEditor: "/ai/api/v1/case/getFileEditor",
  wpsRefreshToken: "/ai/api/v1/file/refreshToken",
  indictmentFiles: "/ai/api/v1/gptIm/indictmentFiles",
  indictmentCreateSession: "/ai/api/v1/gptIm/indictmentCreateSession",
  indictmentFileUpload: `${UPLOAD_URL}/ai/api/v1/gptIm/indictmentFileUpload`,
  indictmentFilePreview: "/ai/api/v1/gptIm/indictmentFilePreview",
  indictmentFileFilling: "/ai/api/v1/gptIm/indictmentFileFilling",
  indictmentSession: "/ai/api/v1/gptIm/indictmentSession",
  selectIndictmentHistory: "/ai/api/v1/gptIm/selectIndictmentHistory",
  indictmentTemplateFileUpload: "/ai/api/v1/gptIm/indictmentTemplateFileUpload",
  specialTrackUrl: "/ai/api/v1/burialPoint/addPageBurialPoint",
  createPolicySession: "/ai/api/v1/enterprise/createPolicySession", // 政策AI-创建会话
  policySessionList: "/ai/api/v1/enterprise/policySessionList", // 政策AI-查询会话列表
  createLegalSession: "/ai/api/v1/enterprise/createLegalSession", // 合规AI-创建会话
  legalSessionList: "/ai/api/v1/enterprise/legalSessionList", //合规AI-查询会话列表
  updateSession: "/ai/api/v1/enterprise/updateSession", // 政策/合规AI-更新会话
  deleteSession: "/ai/api/v1/enterprise/deleteSession", // 政策/合规AI-删除会话
  networkSummaryStream: "/ai/api/v1/enterprise/networkSummaryStream", // 政策/合规AI-联网总结 流式输出
  complianceSummaryStream: "/ai/api/v1/enterprise/complianceSummaryStream", // 合规AI 流式输出
  selectGptChatHistory: "/ai/api/v1/enterprise/selectGptChatHistory", // 政策/合规AI-查询会话历史记录
  createDocumentSession: "/ai/api/v1/enterprise/createTextSession", // 文书AI-创建会话
  deleteTextSession: "/ai/api/v1/enterprise/deleteTextSession", // 文书AI-删除会话
  updateTextSession: "/ai/api/v1/enterprise/updateTextSession", // 文书AI-更新会话名称
  textSessionPin: "/ai/api/v1/enterprise/textSessionPin", // 文书AI-会话置顶
  downloadTextAnswer: "/ai/api/v1/enterprise/downloadTextAnswer", // 文书AI-下载会话结果
  documentSessionList: "/ai/api/v1/enterprise/selectTextSession", // 文书AI-查询会话列表
  selectTextGptChatHistory: "/ai/api/v1/enterprise/selectTextGptChatHistory", // 文书AI-查询会话历史记录
  sendMultiTextFileStream: "/ai/api/v1/enterprise/sendMultiTextFileStream", // 文书AI-文本分析-发送多文件流式问答
  enterpriseUploadMultiFile: "/ai/api/v1/enterprise/uploadMultiFile", // 文书AI-文本分析-上传多文件
  sendGptMessageTextStream: "/ai/api/v1/enterprise/sendGptMessageTextStream", // 文书AI-文书生成-发送消息 流式输出
  getAiQuestionLimit: "/ai/api/v1/enterprise/getAiQuestionLimit", // 查询用户限制次数
  aiSelectNewSession: "/ai/api/v1/enterprise/selectNewSession", // 查询会话最新信息-官网
  identifyUserIntent: "/ai/api/v1/enterprise/identifyUserIntent", // 识别用户意图
  selectIndictmentFilesV2: "/ai/api/v1/gptIm/indictmentFilesV2", // 条件查询法律文书模板文件列表
  selectIndictmentByCondition: "/ai/api/v1/gptIm/selectIndictmentByCondition", // 法律文书模板分类文件列表
  selectIndictmentFileRecord: "/ai/api/v1/gptIm/selectIndictmentFileRecord", // 法律文书模板文件记录
  parseFileAiSummary: "/ai/api/v1/gptIm/parseFileAiSummary", // 法律文书模板文件记录
  updateIndictmentFileEditState: "/ai/api/v1/gptIm/updateIndictmentFileEditState", // 更新要素起诉状编辑状态
  createAiCaseSearchSession: "/ai/api/v1/gptIm/create_ai_case_search_session", //创建类案检索会话
  delAiCaseSearchSession: "/ai/api/v1/gptIm/del_ai_case_search_session", //删除类案检索会话
  updateAiCaseSearchSession: "/ai/api/v1/gptIm/update_ai_case_search_session", //更新类案检索会话名称
  pinAiCaseSearchSession: "/ai/api/v1/gptIm/pin_ai_case_search_session", //类案检索会话置顶
  aiCaseSearchSessionList: "/ai/api/v1/gptIm/ai_case_search_session_list", //查询类案检索会话列表
  addCaseSearchRecord: "/ai/api/v1/gptIm/add_ai_case_search_record", //新增类案检索问答
  aiCaseSearchRecordList: "/ai/api/v1/gptIm/ai_case_search_record_list", //类案检索记录
  aiCaseSearchCaseTreeList: "/ai/api/v1/gptIm/ai_case_search_case_tree_list", //类案检索筛选树
  aiCaseSearchCaseQueryList: "/ai/api/v1/gptIm/ai_case_search_case_query_list", //类案检索列表
  aiCaseSearchMatchDownload: "/ai/api/v1/gptIm/ai_case_search_case_match_download", //类案批量下载
  createSimilarCase: "/ai/api/v1/gptIm/ai_case_search_create_similar_case", //生成类案检索报告
  createSimilarCaseEnterprise: "/ai/api/v1/enterprise/ai_case_search_create_similar_case", //生成类案检索报告-企业版
  caseReportHasFinish: "/ai/api/v1/gptIm/ai_case_search_create_case_report_finish", //判断检索报告是否完成
  addAiCaseUploadMultiFile: "/ai/api/v1/gptIm/add_ai_case_upload_multi_file", //类案检索保存文件信息
  caseReportDownload: "/ai/api/file/download/", //类案检索下载
  aiLawSearchTreeList: "/ai/api/v1/gptIm/ai_case_search_law_tree_list", //法规检索筛选树
  aiLawSearchQuery: "/ai/api/v1/gptIm/ai_case_search_law_query_list_v2", //法规检索
  aiCaseSearchUseful: "/ai/api/v1/gptIm/ai_case_search_useful", //法规检索反馈
  lawMatchDownload: "/ai/api/v1/gptIm/ai_case_search_law_match_download", //法规检索下载（旧接口，CategoryCard.vue 使用）
  lawBatchMatchDownload: "/ai/api/v1/gptIm/ai_case_search_law_batch_match_download", //法规检索批量下载（新接口，CategoryLaw.vue 使用）
  aiCaseGenerateSharing: "ai/api/v1/gptIm/ai_case_generate_sharing", //法规检索获取分享id
  getAiCaseSharing: "/ai/api/v1/gptIm/ai_case_sharing", //法规检索获取分享数据
  caseReportIsGenerate: "/ai/api/v1/gptIm/ai_case_search_case_report_is_generate", //类案检索报告是否在生成
  caseReportList: "/ai/api/v1/gptIm/ai_case_search_search_case_report_list", // 类案检索报告列表
  aiSearchSseInterrupt: "/ai/api/v1/gptIm/aiSearchSseInterrupt", //AI检索中断
  addSceneTypeSession: "/ai/api/v1/gptIm/addSceneTypeSession", // 添加会话场景
  selectSceneTypeButton: "/ai/api/v1/gptIm/selectSceneTypeButton", // 根据会话查找场景指令
  sessionUploadFileNum: "/ai/api/v1/gptIm/sessionUploadFileNum", // 查询会话上传文件数量
  createProfessionalSession: "/ai/api/v1/gptIm/createProfessionalSession", // 专业模型-创建会话
  delProfessionalSession: "/ai/api/v1/gptIm/delProfessionalSession", // 专业模型-删除会话
  confirmUploadMultiFileProfessional: "/ai/api/v1/gptIm/confirmUploadMultiFileProfessional", // 确认文件上传
  updateProfessionalSession: "/ai/api/v1/gptIm/updateProfessionalSession", // 专业模型-更新会话名称
  pinProfessionalSession: "/ai/api/v1/gptIm/pinProfessionalSession", // 专业模型-置顶会话
  professionalSessionList: "/ai/api/v1/gptIm/professionalSessionList", // 专业模型-会话列表
  professionalAiAskStream: "/ai/api/v1/gptIm/professionalAiAskStream", // 专业模型-ai对话
  professionalStudyStream: "/ai/api/v1/gptIm/professionalStudyStream", // 专业模型-法律研究
  professionalMultiFileStream: "/ai/api/v1/gptIm/professionalMultiFileStream", // 专业模型-文本分析
  professionalSearch: "/ai/api/v1/gptIm/professionalSearch", // 专业模型-案例检索
  professionalHistory: "/ai/api/v1/gptIm/professionalHistory", // 专业模型-历史记录
  lawQueryList: "/ai/api/v1/law/queryList", // 专业模型-法规检索
  caseQueryList: "/ai/api/v1/case/queryList", // 专业模型-案例检索
  smartSummaryGenerateStream: `${DATA_URL}/api/v1/case/smartSummaryGenerateStream`, // 专业模型-智能摘要/裁判要点
  searchTabCount: `/ai/api/v1/case/searchTabCount`, // 专业模型-检索总数
  getProfessionalSharing: "/ai/api/v1/gptIm/getProfessionalSharing", // 专业模型-获取分享记录
  verifyLawCase: "/ai/api/v1/gptIm/verifyLawCase", // 一键核查法规案例
  customizeRuleList: "/ai/api/v1/gptIm/customizeRuleList", //合同审查自定义规则列表
  saveCustomizeRule: "/ai/api/v1/gptIm/saveCustomizeRule", //保存合同审查自定义规则
  deleteCustomizeRule: "/ai/api/v1/gptIm/deleteCustomizeRule", //删除合同审查自定义规则
  contractRuleExpand: "/ai/api/v1/gptIm/contractRuleExpand", //合同自定义规则拓展
  sendGptMessageContractOutlineStream: "/ai/api/v1/gptIm/sendGptMessageContractOutlineStream", //合同生成获取大纲
  sendGptMessageContractContentStream: "/ai/api/v1/gptIm/sendGptMessageContractContentStream", //基于大纲生成合同内容
  updateContractOutline: "/ai/api/v1/gptIm/updateContractOutline", //更新合同大纲
  contractContentQueryOptimize: "/ai/api/v1/gptIm/contractContentQueryOptimize", //合同生成用户query一键优化
  textAnalysisVerifyLawCase: "/ai/api/v1/gptIm/textAnalysisVerifyLawCase", // 一键核查法规案例-文本分析
  queryRelatedCaseByCaseId: "/ai/api/v1/case/queryRelatedCaseByCaseId", // 根据案例ID查询相关案例
  removeFileLimit: "/ai/api/v1/gptIm/removeFileLimit", // 移除文件的时候，需要调用这个接口
  resetFileLimit: "/ai/api/v1/gptIm/resetFileLimit", // 重置文件限制
  analysisPercentage: "/ai/api/v1/gptIm/analysisPercentage", // 获取分析进度
  updateContractQuestionAnswer: "/ai/api/v1/gptIm/updateContractQuestionAnswer", // 更新合同AI回答信息
  showIndictmentExample: "/ai/api/v1/gptIm/showIndictmentExample", // 记录法律文书实例访问接口
  sendGptMessageContractBasicAnswerStream: "/ai/api/v1/gptIm/sendGptMessageContractBasicAnswerStream", // 合同生成模型普通回答接口
  selectAnswer: "/ai/api/v1/gptIm/selectAnswer", // 合同生成模型普通回答接口-企业版
  queryKnowledgeInfo: `${APPLET_URL}/api/v1/gptLawyer/knowledgeInfo`, // 查询知识库详情信息
  sendGptMessageTraditionalPleadingsStream: "/ai/api/v1/gptIm/sendGptMessageTraditionalPleadingsStream", // 生成传统法律文书
  downloadTraditionalIndictmentAnswer: "/ai/api/v1/gptIm/downloadTraditionalIndictmentAnswer", // 下载传统文书接口
  createTraditionalIndictmentSession: "/ai/api/v1/gptIm/createTraditionalIndictmentSession", // 创建传统文书会话接口
  conversionIndictment: "/ai/api/v1/gptIm/conversionIndictment", // 删除传统文书会话接口
  saveBodyReviewRecord: "/ai/api/v1/gptIm/saveBodyReviewRecord", // 保存合同主体审查记录
  getBodyReviewRecord: "/ai/api/v1/gptIm/getBodyReviewRecord", // 获取合同主体审查记录
  enterpriseBasicInfo: "/ai/api/v1/gptIm/enterpriseBasicInfo", // 企业基本信息
  enterpriseBasicInfoHistory: "/ai/api/v1/gptIm/enterpriseBasicInfoHistory", // 企业基本信息历史记录
  enterpriseBodyInfo: "/ai/api/v1/gptIm/enterpriseBodyInfo", // 企业主体资信与合规审查
  contractBodyHistory: "/ai/api/v1/gptIm/contractBodyHistory", // 企业主体信息历史记录
  queryReviewPartyBName: "/ai/api/v1/gptIm/queryReviewPartyName", // 获取审查方名称
  fileAbstract: "/ai/api/v1/gptIm/fileAbstract", // 文件摘要
  intentionIdentify: "/ai/api/v1/gptIm/intentionIdentify", // 意图识别
  guideQuestion: "/ai/api/v1/gptIm/guideQuestion", // 引导提问
  jumpPage: "/ai/api/v1/gptIm/jumpPage", // 跳转页面
  createAssistantSession: "/ai/api/v1/gptIm/createAssistantSession", // 创建会话
  assistantSessionList: "/ai/api/v1/gptIm/assistantSessionList", // 查询会话列表
  selectNewSessionV2: "/ai/api/v1/gptIm/selectNewSessionV2", // 查询会话最新信息-官网
  toppingSession: "/ai/api/v1/gptIm/toppingSession", // 置顶对话记录
  selectAiAssistantHistory: "/ai/api/v1/gptIm/selectAiAssistantHistory", // 历史记录
  questionClassify: "/ai/api/v1/gptIm/questionClassify", // 问题分类
  conversionIndictmentTemplate: "/ai/api/v1/gptIm/conversionIndictmentTemplate", // 匹配模板
  // selectAiAssistantHistoryV2: "/ai/api/v1/gptIm/selectAiAssistantHistoryV2", // 历史记录
  // assistantSessionListV2: "/ai/api/v1/gptIm/assistantSessionListV2", // 查询会话列表
  // createAssistantSessionV2: "/ai/api/v1/gptIm/createAssistantSessionV2", // 创建会话
  updateTextAnalysisAnswer: "/ai/api/v1/gptIm/updateTextAnalysisAnswer", // 文本分析 编辑功能
  //自定义指令
  selectExample: "/ai/api/v1/exampleBase/selectExample", // 查询自定义指令
  saveExample: "/ai/api/v1/exampleBase/saveExample", //保存自定义指令
  deleteExample: "/ai/api/v1/exampleBase/deleteExample/", // 删除自定义指令
  studyExample: "/ai/api/v1/gptIm/studyExample", // 法律研究示例
  studyExampleSse: "/ai/api/v1/gptIm/studyExampleSse", // 法律研究示例SSE
  generateContractContentByTemplateSseStream: "/ai/api/v1/gptIm/generateContractContentByTemplateSseStream", // 上传模板调用接口
  studyQueryOptimize: "/ai/api/v1/gptIm/studyQueryOptimize", // ai对话、法律研究提示词优化
  aiSearchQueryOptimize: "/ai/api/v1/gptIm/aiSearchQueryOptimize", // ai检索提示词优化
  // 我的文档
  docDeleteDocument: "/api/v1/user/document/deleteFolder", // 删除文档（单个/批量）
  docCreateFolder: "/api/v1/user/document/createFolder", // 创建文件夹
  docMoveDocument: "/api/v1/user/document/moveDocument", // 移动文件/文件夹
  docQueryTree: "/api/v1/user/document/queryDocumentTree", // 查询文档树（GET）
  docQueryList: "/api/v1/user/document/queryDocumentList", // 查询文档分页列表（POST）
  docModifyFolderName: "/api/v1/user/document/modifyFolderName", // 修改文件夹名称
  docSearch: "/api/v1/user/document/qeueryPageDocument", // 检索文档（分页，GET）
};
export default ($axios: AxiosInstance) => {
  if (process.env.NODE_ENV === "development") {
    $axios.defaults.baseURL = API_URL;
  } else {
    $axios.defaults.baseURL = "";
  }

  return {
    // 获取历史对话列表
    getSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getSessionList,
      }),
    // 删除对话记录
    removeSession: (sessionId: string) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.removeSession,
        data: { sessionId },
      }),
    // 注册IM用户
    registerTIM: () => sendRequest($axios, { method: "POST", url: url.registerTIM }),
    // im上传文件到oss
    uploadFileIm: (form: FormData, onProgress?: (complete: number) => void) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadFileIm,
        data: form,
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          const total = progressEvent.total || 0;
          const loaded = progressEvent.loaded || 0;
          const complete = total ? ((loaded / total) * 100) | 0 : 0;
          if (onProgress) {
            onProgress(complete);
          }
        },
      }),
    // gpt文件上传
    uploadFileGpt: (form: FormData, onProgress?: (complete: number) => void) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadFileGpt,
        data: form,
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          const total = progressEvent.total || 0;
          const loaded = progressEvent.loaded || 0;
          const complete = total ? ((loaded / total) * 100) | 0 : 0;
          if (onProgress) {
            onProgress(complete);
          }
        },
      }),
    // 获取文件上传临时链接
    fileUploadTempUrl: (form: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.fileUploadTempUrl,
        data: form,
      }),

    // 文件上传之后再去调用大模型接口保存
    uploadFileToGptV2: (form: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadFileToGptV2,
        data: form,
      }),
    uploadFileToGptNew: (form: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadFileToGptNew,
        data: form,
      }),
    // 合同审查
    uploadFileToGptV3: (form: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadFileToGptV3,
        data: form,
      }),
    // 获取工具指令列表
    getDirectiveList: () => sendRequest($axios, { method: "GET", url: url.getDirectiveList }),
    //查询合同生成历史记录
    getContractHistoryList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getContractHistoryList,
        data: params,
      }),
    // 查询对话历史记录
    getSessionChatHistoryList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        //url: "/api/v1/gptIm/selectGptChatHistory",
        url: url.getSessionChatHistoryList,
        data: params,
      }),

    // 查询参考案例
    getRelatedCaseList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getRelatedCaseList,
        data: params,
      }),
    // 根据fileId获取参考案例
    getFileRelatedCaseList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getFileRelatedCaseList,
        data: params,
      }),
    // 提交反馈
    submitFeedback: (params: any) =>
      sendRequest($axios, {
        method: "PUT",
        url: url.submitFeedback,
        data: params,
      }),
    // 获取剩余问答次数
    getLimitUser: () => sendRequest($axios, { method: "GET", url: url.getLimitUser }),
    // 发送问题
    sendGptMessage: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.sendGptMessage,
        data: params,
      }),
    // 发送问题 大模型流式输出接口
    sendGptMessageStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStream, "POST", params, config),
    /**
     * 发送问题v3 sendGptMessageStreamV4
     */
    sendGptMessageStreamV4: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStreamV4, "POST", params, config),

    /**
     * 发送问题v4 企业版
     */
    sendGptMessageStreamV4Enterprise: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStreamV4Enterprise, "POST", params, config),

    sendGptMessageFileInstructStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageFileInstructStream, "POST", params, config),

    /**
     * 发送问题（指令） 大模型流式输出接口
     */
    sendGptMessageInstructStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageInstructStream, "POST", params, config),
    // 文件内容解析提问问答 大模型流式输出接口
    sendGptMessageFileStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageFileStream, "POST", params, config),
    // 大模型全局订阅
    subscriptionGlobal: (config?: FetchEventSourceConfig) =>
      sendSSERequest(url.subscriptionGlobal, "POST", null, config),
    // 新建对话
    createSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createSession,
      }),
    // 会话置顶/取消置顶
    topSession: (params: any) =>
      sendRequest($axios, {
        method: "PUT",
        url: url.topSession,
        data: params,
      }),
    // 筛选律师并插入
    getLawyerAndInsert: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getLawyerAndInsert,
        data: params,
      }),
    // 查询律师信息
    getLawyerInfo: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: url.getLawyerInfo,
        params,
      }),
    // 咨询律师
    submitConsultLawyer: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.submitConsultLawyer,
        data: params,
      }),
    // 更新会话
    updateSessionRecord: (params: any) =>
      sendRequest($axios, {
        method: "PUT",
        url: url.updateSessionRecord,
        data: params,
      }),
    // 获取搜索建议数据
    getSearchSuggestData: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getSearchSuggestData,
        data: params,
      }),
    // 生成分享ID
    createShareData: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.createShareData,
        data: params,
      }),
    /**
     * 获取分享记录
     */
    getShareRecordListV0: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url: baseUrl ? `${baseUrl}${url.getShareRecordListV0}/${shareId}` : `${url.getShareRecordListV0}/${shareId}`,
      }),
    // 获取分享记录
    getShareRecordList: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url: baseUrl ? `${baseUrl}${url.getShareRecordList}/${shareId}` : `${url.getShareRecordList}/${shareId}`,
      }),
    // 获取法搜小程序链接
    getShortUrlCode: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getShortUrlCode,
      }),
    // 创建指令会话
    createDirective: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.createDirective,
        params,
      }),
    // 查询指令会话历史记录
    getDirectiveChatHistoryList: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getDirectiveChatHistoryList,
        data: params,
      }),
    // 查询指令类别
    getPromptType: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getPromptType,
      }),
    // 批量删除会话id
    batchDelete: (params: any) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.batchDelete,
        data: params,
      }),
    // 查询提示词
    getPrompt: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.getPrompt,
        data: params,
      }),
    // 创建文件会话
    createFileSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createFileSession,
      }),
    // 删除文件会话
    deleteFileSession: (params: any) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.deleteFileSession,
        data: params,
      }),
    //获取多文件会话历史记录
    selectMultiFileHistory: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectMultiFileHistory,
        data: params,
      }),
    //获取多文件会话历史记录v2
    selectMultiFileHistoryV2: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectMultiFileHistoryV2,
        data: params,
      }),
    sendMultiFileStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendMultiFileStream, "POST", params, config),
    // 新版多文件分析流式输出接口
    sendMultiFileStreamV2: (params: API.SendMultiFileStreamV2Params, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendMultiFileStreamV2, "POST", params, config),
    // 文书AI多文件分析流式输出接口
    sendMultiFileStreamV2AI: (params: API.SendMultiFileStreamV2Params, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendMultiFileStreamV2AI, "POST", params, config),
    // 文件会话置顶
    topFileSession: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.topFileSession,
        data: params,
      }),
    // 编辑文件会话名称
    editFileSession: (params: API.EditFileSessionParams) =>
      sendRequest<boolean>($axios, {
        method: "PUT",
        url: url.editFileSession,
        data: params,
      }),
    // 获取文件会话列表
    getFileSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getFileSessionList,
      }),
    //文本分析下载
    downloadAnalyse: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.downloadAnalyse,
        data: params,
      }),
    // 保存文件
    saveFile: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.saveFile,
        data: params,
      }),
    //多文件上传
    uploadMultiFile: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadMultiFile,
        data: params,
      }),
    // 多文件上传v2
    uploadMultiFileV2: (params: AI.UploadMultiFileV2Params) =>
      sendRequest($axios, {
        method: "POST",
        url: url.uploadMultiFileV2,
        data: params,
      }),

    //取消文件上传
    delMultiFileRecord: (params: any) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.delMultiFileRecord,
        data: params,
      }),
    //确认文件上传
    confirmUploadMultiFile: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.confirmUploadMultiFile,
        data: params,
      }),
    //获取多文件分享记录
    getFileSharing: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url: baseUrl ? `${baseUrl}/${url.getFileSharing}/${shareId}` : `${url.getFileSharing}/${shareId}`,
      }),
    screenLawyer: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.screenLawyer,
        data: { lawyerInfoNum: 4 },
      }),
    /**
     * 创建法律研究会话
     */
    createStudySession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createStudySession,
      }),
    /**
     * 获取法律研究会话列表
     */
    getStudySessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getStudySessionList,
      }),
    /**
     * 发送法律研究消息 - ai总结请求
     */
    sendGptMessageStudyStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStreamSummaryAi, "POST", params, config),

    /**
     * 发送法律研究 - 法律分析请求
     */
    sendGptMessageStudyAnalysisStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStudyStreamAnalysis, "POST", params, config),
    /**
     * 发送法律研究 - 法律分析请求新
     */
    sendGptMessageStudyAnalysisStreamNew: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageStudyAnalysisStreamNew, "POST", params, config),
    /**暂停研究 */
    studySseInterrupt: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.studySseInterrupt,
        data: params,
      }),
    /**
     * 法律研究获取历史记录接口 /
     */
    selectStudyGptChatHistory: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectStudyGptChatHistory,
        data: params,
      }),
    /**
     * 法律研究获取分享数据
     */
    getStudySharing: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url: baseUrl ? `${baseUrl}/${url.getStudySharing}/${shareId}` : `${url.getStudySharing}/${shareId}`,
      }),

    /**
     * 法律研究反问
     */
    sendStudyRhetoricalQuestionStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendStudyRhetoricalQuestionStream, "POST", params, config),
    /**
     * 文件下载
     */
    downloadFile: (url: string, params: any, fileName?: "") => {
      downloadPOST(url, params, fileName);
    },
    /**
     * 文件导出
     */
    exportFile: (params: any, fileName?: "") => {
      downloadPOST(url.exportFile, params, fileName);
    },

    /**
     * 法律研究文件导出（返回 Blob，用于下载后再上传场景）
     */
    exportFileBlob: (params: any): Promise<Blob> =>
      $axios.post(url.exportFile, params, { responseType: "blob" }).then((res: any) => res as Blob),

    // 创建会话 - 合同
    createContractSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createContractSession,
      }),

    // 删除会话 - 合同
    deleteContractSession: (params: any) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.deleteContractSession,
        data: params,
      }),

    // 会话列表 - 合同
    getContractSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.getContractSessionList,
      }),

    // 置顶 - 合同
    filePinContract: (params: any) => sendRequest($axios, { method: "POST", url: url.filePinContract, data: params }),

    // 下载 - 合同
    downloadContractAnswer: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.downloadContractAnswer,
        data: params,
      }),

    sendGptMessageContractStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageContractStream, "POST", params, config),

    // 合同流式输出 - 企业版
    sendGptMessageContractStreamEnterprise: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageContractStreamEnterprise, "POST", params, config),

    // 更新会话 - 合同
    updateContractSession: (params: any) =>
      sendRequest($axios, {
        method: "PUT",
        url: url.updateContractSession,
        data: params,
      }),

    // 检查是否存在新会话
    selectNewSession: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectNewSession,
        data: params,
      }),

    //会话列表 - 合同审查
    getReviewListSession: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.contractReviewListSession,
      }),

    //历史记录 - 合同审查
    getReviewHistory: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractReviewHistory,
        data: params,
      }),

    //创建会话 - 合同审查
    createReviewSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.reviewCreateSession,
      }),
    //保存文件 - 合同审查
    contractReviewFileUpload: (form: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.reviewFileUpload,
        data: form,
      }),
    //合同审查
    contractReview: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractReview,
        data: params,
      }),
    //在线预览 - 合同审查
    reviewFilePreview: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.reviewFilePreview,
        data: params,
      }),
    //刷新token - 合同审查
    reviewRefreshToken: (token: string) =>
      sendRequest($axios, {
        method: "GET",
        url: url.reviewRefreshToken + token,
      }),
    //下载 - 合同审查源文件
    downloadContractReview: (query: string) =>
      sendRequest($axios, {
        method: "GET",
        url: url.downloadContractReview + query,
        headers: {
          function: "contract_review",
        },
      }),
    //下载 - 合同审查修订版
    downloadContractReviewRevised: (params: any, fileName = "") => {
      downloadPOST(url.downloadContractReviewRevised, params, fileName);
    },
    //风险修订 - 合同审查
    revisionRisk: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        //url: `${url.revisionRisk}?riskId=${params.riskId}&type=${params.type}`,
        url: url.revisionRisk,
        data: params,
      }),
    //风险移除 - 合同审查
    removeRisk: (id: string) =>
      sendRequest($axios, {
        method: "GET",
        url: `${url.removeRisk}?riskId=${id}`,
      }),
    //建议修改 - 合同审查
    updateAiSuggest: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateAiSuggest,
        data: params,
      }),
    //剩余次数 - 合同审查
    contractReviewCount: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.contractReviewCount,
      }),

    //获取示例 - 合同审查
    getContractReviewExample: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.contractReviewExample,
      }),
    //sse - 合同审查
    contractReviewSse: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.contractReviewSse, "POST", params, config),

    //sse - 合同审查 企业版
    contractReviewSseEnterprise: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.contractReviewSseEnterprise, "POST", params, config),

    //检测用户是否有功能内测权限 - 合同审查
    // queryInternalBetaPassStatus: (params: any) =>
    //   sendRequest($axios, {
    //     method: "POST",
    //     url: url.queryInternalBetaPassStatus,
    //     data: params,
    //   }),

    //合同审查返回内测通过分类列表
    contractReviewTypes: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: url.contractReviewTypes,
        params,
      }),

    //合同摘要 - 合同审查
    contractAbstract: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractAbstract,
        data: params,
      }),
    //合同摘要记录 - 合同审查
    contractAbstractHistory: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractAbstractHistory,
        data: params,
      }),
    //问律师 - 深i企问律师
    sendGptMessageSIQ: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.sendGptMessageSIQ,
        data: params,
      }),
    //换一换（律师列表） - 深i企问律师
    screenLawyerSIQ: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.screenLawyerSIQ,
        data: { lawyerInfoNum: 4 },
      }),
    //换一换（问答） - 深i企问律师
    screenLawyerAndInsertSIQ: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.screenLawyerAndInsertSIQ,
        data: params,
      }),
    //律师信息 - 深i企问律师
    getLawyerInfoSIQ: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: url.lawyerInfoSIQ,
        params,
      }),

    //律师咨询请求 - 深i企问律师
    saveLeaveMessageSIQ: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.saveLeaveMessageSIQ,
        data: params,
      }),

    queryToken: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.queryToken,
      }),

    // 获取文件下载临时链接
    fileSecretDownloadUrl: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.fileSecretDownloadUrl,
        data: params,
      }),
    // 获取文件下载临时链接
    getFileEditor: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: url.getFileEditor,
        params,
      }),
    // 刷新wps token
    wpsRefreshToken: (token: string) =>
      sendRequest($axios, {
        method: "GET",
        url: `${url.wpsRefreshToken}/${token}`,
      }),
    // 要素起诉状列表
    indictmentFiles: () =>
      sendRequest<API.IndictmentFilesResult[]>($axios, {
        method: "GET",
        url: url.indictmentFiles,
      }),
    // 要素起诉状创建会话
    indictmentCreateSession: (params: API.IndictmentCreateSessionParams) =>
      sendRequest<API.IndictmentCreateSessionResult>($axios, {
        method: "POST",
        url: url.indictmentCreateSession,
        data: params,
      }),
    // 要素起诉状模板上传
    indictmentFileUpload: (params: API.IndictmentFileUploadParams) =>
      sendRequest<API.IndictmentFileUploadResult>($axios, {
        method: "POST",
        url: url.indictmentFileUpload,
        data: params,
      }),
    // 要素起诉状模板在线预览编辑
    indictmentFilePreview: (params: API.IndictmentFilePreviewParams) =>
      sendRequest<API.IndictmentFilePreviewResult>($axios, {
        method: "POST",
        url: url.indictmentFilePreview,
        data: params,
      }),
    // 要素起诉状填充
    indictmentFileFilling: (params: API.IndictmentFileFillingParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.indictmentFileFilling, "POST", params, config),
    // 要素起诉状会话列表
    indictmentSession: () =>
      sendRequest<API.IndictmentSessionResult[]>($axios, {
        method: "GET",
        url: url.indictmentSession,
      }),
    // 要素起诉状 查询历史记录
    selectIndictmentHistory: (params: API.SelectIndictmentHistoryParams) =>
      sendRequest<API.SelectIndictmentHistoryResult[]>($axios, {
        method: "POST",
        url: url.selectIndictmentHistory,
        data: params,
      }),
    // 要素起诉状模板上传
    indictmentTemplateFileUpload: (params: API.IndictmentTemplateFileUploadParams) =>
      sendRequest<API.IndictmentTemplateFileUploadResult>($axios, {
        method: "POST",
        url: url.indictmentTemplateFileUpload,
        data: params,
      }),
    // 特殊埋点
    specialTrack: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.specialTrackUrl,
        data: params,
      }),

    // 合规AI-创建会话
    createLegalSession: () =>
      sendRequest<API.CreateLegalSessionResult>($axios, {
        method: "POST",
        url: url.createLegalSession,
      }),

    // 合规AI-查询会话列表
    legalSessionList: () =>
      sendRequest<API.LegalSessionListResult[]>($axios, {
        method: "GET",
        url: url.legalSessionList,
      }),

    // 政策AI-创建会话
    createPolicySession: () =>
      sendRequest<API.CreatePolicySessionResult>($axios, {
        method: "POST",
        url: url.createPolicySession,
      }),

    // 政策AI-查询会话列表
    policySessionList: () =>
      sendRequest<API.PolicySessionListResult[]>($axios, {
        method: "GET",
        url: url.policySessionList,
      }),

    // 文书AI-创建会话
    createDocumentSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createDocumentSession,
      }),

    // 文书AI-查询会话列表
    documentSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.documentSessionList,
      }),

    // 文书AI-删除会话
    deleteTextSession: (params: { sessionId: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.deleteTextSession,
        data: params,
      }),

    // 文书AI-更新会话名称
    updateTextSession: (params: API.UpdateTextSessionParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateTextSession,
        data: params,
      }),

    // 文书AI-会话置顶
    textSessionPin: (params: API.TextSessionPinParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.textSessionPin,
        data: params,
      }),

    // 文书AI-下载会话结果
    downloadTextAnswer: (params: API.DownloadTextAnswerParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.downloadTextAnswer,
        data: params,
      }),

    // 文书AI-查询会话列表
    documentAiSessionList: () =>
      sendRequest<API.DocumentAiSessionListResult[]>($axios, {
        method: "GET",
        url: url.documentSessionList,
      }),

    // 文书AI-查询会话历史记录
    selectTextGptChatHistory: (params: API.SelectTextGptChatHistoryParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectTextGptChatHistory,
        data: params,
      }),

    // 文书AI-文本分析-发送多文件流式问答
    sendMultiTextFileStream: (params: API.SendMultiTextFileStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendMultiTextFileStream, "POST", params, config),

    //文书AI-文书生成-发送消息 流式输出
    sendGptMessageTextStream: (params: API.SendGptMessageTextStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.sendGptMessageTextStream, "POST", params, config),

    //文书AI-文本分析-上传多文件
    enterpriseUploadMultiFile: (params: API.EnterpriseUploadMultiFileParams) =>
      sendRequest<API.EnterpriseUploadMultiFileResult>($axios, {
        method: "POST",
        url: url.enterpriseUploadMultiFile,
        data: params,
      }),

    // 政策/合规AI-联网总结 流式输出
    networkSummaryStream: (params: API.NetworkSummaryStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.networkSummaryStream, "POST", params, config),

    // 合规AI-流式输出
    complianceSummaryStream: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.complianceSummaryStream, "POST", params, config),

    // 政策/合规AI-查询会话历史记录
    selectGptChatHistory: (params: API.SelectGptChatHistoryParams) =>
      sendRequest<API.SelectGptChatHistoryResult[]>($axios, {
        method: "POST",
        url: url.selectGptChatHistory,
        data: params,
      }),

    // 政策/合规AI-更新会话
    updateSession: (params: API.UpdateSessionParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateSession,
        data: params,
      }),

    // 政策/合规AI-删除会话
    deleteSession: (params: { sessionId: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.deleteSession,
        data: params,
      }),

    // 查询用户限制次数
    getAiQuestionLimit: (params: { aiType: string }) =>
      sendRequest($axios, {
        method: "GET",
        url: url.getAiQuestionLimit,
        params,
      }),

    // 查询会话最新信息-官网
    aiSelectNewSession: (params: { sessionType: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiSelectNewSession,
        data: params,
      }),

    // 识别用户意图
    identifyUserIntent: (params: API.IdentifyUserIntentParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.identifyUserIntent,
        data: params,
      }),

    // 条件查询法律文书模板文件列表
    selectIndictmentFilesV2: (params: API.SelectIndictmentFilesV2Params) =>
      sendRequest<API.SelectIndictmentByConditionResultData[]>($axios, {
        method: "POST",
        url: url.selectIndictmentFilesV2,
        data: params,
      }),

    // 文书AI-文书生成-查询文书列表
    selectIndictmentByCondition: (params: API.SelectIndictmentByConditionParams) =>
      sendRequest<API.SelectIndictmentByConditionResult>($axios, {
        method: "POST",
        url: url.selectIndictmentByCondition,
        data: params,
      }),

    // 法律文书模板检索历史
    selectIndictmentFileRecord: () =>
      sendRequest<API.SelectIndictmentFileRecordResult[]>($axios, {
        method: "GET",
        url: url.selectIndictmentFileRecord,
      }),

    // 法律文书上传文档解析内容
    parseFileAiSummary: (params: API.ParseFileAiSummaryParams) =>
      sendRequest<string>($axios, {
        method: "POST",
        url: url.parseFileAiSummary,
        data: params,
      }),

    // 更新要素起诉状编辑状态
    updateIndictmentFileEditState: (params: API.updateIndictmentFileEditStatePrams) =>
      sendRequest<API.updateIndictmentFileEditStateResult>($axios, {
        method: "POST",
        url: url.updateIndictmentFileEditState,
        data: params,
      }),

    //类案检索-创建会话
    createAiCaseSearchSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createAiCaseSearchSession,
      }),
    //类案检索-删除会话
    delAiCaseSearchSession: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.delAiCaseSearchSession,
        data: params,
      }),
    //类案检索-更新会话名称
    updateAiCaseSearchSession: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateAiCaseSearchSession,
        data: params,
      }),
    //类案检索-置顶会话
    pinAiCaseSearchSession: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.pinAiCaseSearchSession,
        data: params,
      }),
    //类案检索-查询会话列表
    aiCaseSearchSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.aiCaseSearchSessionList,
      }),
    //类案检索-新增问答
    addCaseSearchRecord: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.addCaseSearchRecord,
        data: params,
      }),
    //类案检索-历史记录
    aiCaseSearchRecordList: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiCaseSearchRecordList,
        data: params,
      }),
    //类案检索-筛选树
    aiCaseSearchCaseTreeList: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiCaseSearchCaseTreeList,
        data: params,
      }),
    //类案检索-类案列表
    aiCaseSearchCaseQueryList: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiCaseSearchCaseQueryList,
        data: params,
      }),
    //类案检索-批量下载
    aiCaseSearchMatchDownload: (params: Record<string, any>) => {
      downloadPOST(url.aiCaseSearchMatchDownload, params);
    },
    // sendRequest($axios, {
    //   method: "POST",
    //   url: url.aiCaseSearchMatchDownload,
    //   data: params,
    // }),
    //类案检索-生成类案报告
    createSimilarCase: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.createSimilarCase,
        data: params,
      }),
    //类案检索-生成类案报告 企业版
    createSimilarCaseEnterprise: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.createSimilarCaseEnterprise,
        data: params,
      }),
    //类案检索-保存文件信息
    addAiCaseUploadMultiFile: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.addAiCaseUploadMultiFile,
        data: params,
      }),
    //类案检索- 判断类案报告是否生成完成
    caseReportHasFinish: (params: any) =>
      sendRequest($axios, {
        method: "GET",
        url: url.caseReportHasFinish,
        params,
      }),
    //类案检索 - 下载
    caseReportDownload: (query: string) =>
      sendRequest($axios, {
        method: "GET",
        url: url.caseReportDownload + query,
        headers: {
          function: "ai_search",
        },
      }),
    //类案检索 - 类案报告是否在生成
    caseReportIsGenerate: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.caseReportIsGenerate,
      }),

    //类案检索 -类案报告列表
    caseReportList: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "GET",
        url: url.caseReportList,
        params,
      }),

    //类案检索 - 停止生成
    aiSearchSseInterrupt: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiSearchSseInterrupt,
        data: params,
      }),

    //法规检索-筛选树
    aiLawSearchTreeList: (params: API.LawSearchTreeListParams) =>
      sendRequest<API.LawSearchTreeListResult>($axios, {
        method: "POST",
        url: url.aiLawSearchTreeList,
        data: params,
      }),

    //法规检索
    aiLawSearchQuery: (params: Record<string, any>, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.aiLawSearchQuery, "POST", params, config),

    //法规检索-反馈
    aiCaseSearchUseful: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiCaseSearchUseful,
        data: params,
      }),

    //法规检索-下载（旧接口，CategoryCard.vue 使用）
    lawMatchDownload: (params: Record<string, any>) => {
      downloadPOST(url.lawMatchDownload, params);
    },
    //法规检索-批量下载（新接口，CategoryLaw.vue 使用）
    lawBatchMatchDownload: (params: API.LawBatchDownloadParams) => {
      downloadPOST(url.lawBatchMatchDownload, params);
    },
    //法规检索-获取分享id
    aiCaseGenerateSharing: (params: Record<string, any>) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiCaseGenerateSharing,
        data: params,
      }),

    //法规检索-获取分享数据
    getAiCaseSharing: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url: baseUrl ? `${baseUrl}${url.getAiCaseSharing}/${shareId}` : `${url.getAiCaseSharing}/${shareId}`,
      }),
    // 添加会话场景
    addSceneTypeSession: (params: API.AddSceneTypeSessionParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.addSceneTypeSession,
        data: params,
      }),

    //根据会话查找场景指令
    selectSceneTypeButton: (params: API.SelectSceneTypeButtonParams) =>
      sendRequest($axios, {
        method: "GET",
        url: url.selectSceneTypeButton,
        params,
      }),

    // 查询会话上传文件数量
    sessionUploadFileNum: (params: API.SelectSceneTypeButtonParams) =>
      sendRequest($axios, {
        method: "GET",
        url: url.sessionUploadFileNum,
        params,
      }),

    // 专业模型-创建会话
    createProfessionalSession: (params: API.CreateProfessionalSessionParams) =>
      sendRequest<string>($axios, {
        method: "POST",
        url: url.createProfessionalSession,
        data: params,
      }),

    // 专业模型-删除会话
    delProfessionalSession: (params: API.DelProfessionalSessionParams) =>
      sendRequest<boolean>($axios, {
        method: "DELETE",
        url: url.delProfessionalSession,
        data: params,
      }),

    // 专业模型-确认文件上传
    confirmUploadMultiFileProfessional: (params: API.ConfirmUploadMultiFileProfessionalParams) =>
      sendRequest<API.ConfirmUploadMultiFileProfessionalResult>($axios, {
        method: "POST",
        url: url.confirmUploadMultiFileProfessional,
        data: params,
      }),

    // 专业模型-更新会话名称
    updateProfessionalSession: (params: API.UpdateProfessionalSessionParams) =>
      sendRequest<boolean>($axios, {
        method: "POST",
        url: url.updateProfessionalSession,
        data: params,
      }),

    // 专业模型-置顶会话
    pinProfessionalSession: (params: API.PinProfessionalSessionParams) =>
      sendRequest<boolean>($axios, {
        method: "POST",
        url: url.pinProfessionalSession,
        data: params,
      }),

    // 专业模型-会话列表
    professionalSessionList: () =>
      sendRequest<API.ProfessionalSessionListResult[]>($axios, {
        method: "GET",
        url: url.professionalSessionList,
      }),

    // 专业模型-ai对话
    professionalAiAskStream: (params: API.ProfessionalAiAskStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.professionalAiAskStream, "POST", params, config),

    // 专业模型-法律研究
    professionalStudyStream: (params: API.ProfessionalStudyStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.professionalStudyStream, "POST", params, config),

    // 专业模型-文本分析
    professionalMultiFileStream: (params: API.ProfessionalMultiFileStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.professionalMultiFileStream, "POST", params, config),

    // 专业模型-案例检索
    professionalSearch: (params: API.ProfessionalSearchParams) =>
      sendRequest<API.ProfessionalSearchResult>($axios, {
        method: "POST",
        url: url.professionalSearch,
        data: params,
      }),

    // 专业模型-历史记录
    professionalHistory: (params: API.ProfessionalHistoryParams) =>
      sendRequest<API.ProfessionalHistoryResult[]>($axios, {
        method: "POST",
        url: url.professionalHistory,
        data: params,
      }),

    // 专业模型-法规检索
    lawQueryList: (params: API.LawQueryListParams) =>
      sendRequest<API.LawQueryListResult>($axios, {
        method: "POST",
        url: url.lawQueryList,
        data: params,
      }),

    // 专业模型-案例检索
    caseQueryList: (params: API.CaseQueryListParams) =>
      sendRequest<API.CaseQueryListResult>($axios, {
        method: "POST",
        url: url.caseQueryList,
        data: params,
      }),

    // 专业模型-智能摘要/裁判要点
    smartSummaryGenerateStream: (params: API.SmartSummaryGenerateStreamParams, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.smartSummaryGenerateStream, "POST", params, config, true),

    // 专业模型-智能摘要/裁判要点
    searchTabCount: (params: API.CaseQueryListParams) =>
      sendRequest<API.SearchTabCountResult>($axios, {
        method: "POST",
        url: url.searchTabCount,
        data: params,
        headers: {
          library: "bankruptcy",
        },
      }),

    // 专业模型-文本分析-获取分享记录
    getProfessionalSharing: (shareId: string, baseUrl: string = "") =>
      sendRequest($axios, {
        method: "GET",
        url:
          baseUrl ? `${baseUrl}/${url.getProfessionalSharing}/${shareId}` : `${url.getProfessionalSharing}/${shareId}`,
      }),

    // 一键核查法规案例
    verifyLawCase: (params: API.VerifyLawCaseParams) =>
      sendRequest<API.VerifyLawCaseResult>($axios, {
        method: "POST",
        url: url.verifyLawCase,
        data: params,
      }),

    // 合同审查自定义规则列表
    customizeRuleList: (params: API.CustomizeRuleListParams) =>
      sendRequest<API.CustomizeRuleListResult[]>($axios, {
        method: "POST",
        url: url.customizeRuleList,
        data: params,
      }),

    // 保存合同审查自定义规则
    saveCustomizeRule: (params: API.SaveCustomizeRuleParams) =>
      sendRequest<API.CustomizeRuleListResult>($axios, {
        method: "POST",
        url: url.saveCustomizeRule,
        data: params,
      }),

    // 删除合同审查自定义规则
    deleteCustomizeRule: (id: string) =>
      sendRequest($axios, {
        method: "POST",
        url: url.deleteCustomizeRule,
        data: { id },
      }),

    // 合同自定义规则拓展
    contractRuleExpand: (params: API.ContractRuleExpandParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractRuleExpand,
        data: params,
      }),

    //合同生成获取大纲
    sendGptMessageContractOutlineStream: (
      params: API.SendGptMessageContractOutlineStreamParams,
      config?: FetchEventSourceConfig,
    ) => sendSSERequest(url.sendGptMessageContractOutlineStream, "POST", params, config),

    // 基于大纲生成合同内容
    sendGptMessageContractContentStream: (
      params: API.SendGptMessageContractContentStreamParams,
      config?: FetchEventSourceConfig,
    ) => sendSSERequest(url.sendGptMessageContractContentStream, "POST", params, config),

    // 更新合同大纲
    updateContractOutline: (params: API.UpdateContractOutlineParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateContractOutline,
        data: params,
      }),

    //合同生成用户query一键优化
    contractContentQueryOptimize: (params: API.ContractContentQueryOptimizeParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.contractContentQueryOptimize,
        data: params,
      }),
    // 一键核查法规案例 -文本分析
    textAnalysisVerifyLawCase: (params: API.VerifyLawCaseParams) =>
      sendRequest<API.VerifyLawCaseResult>($axios, {
        method: "POST",
        url: url.textAnalysisVerifyLawCase,
        data: params,
      }),
    // 根据案例ID查询相关案例
    queryRelatedCaseByCaseId: (params: API.QueryRelatedCaseByCaseIdParams) =>
      sendRequest<API.QueryRelatedCaseByCaseIdResult>($axios, {
        method: "GET",
        url: url.queryRelatedCaseByCaseId,
        params,
      }),
    // 移除文件限制
    removeFileLimit: (params: API.RemoveFileLimitParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.removeFileLimit,
        data: params,
      }),
    // 重置文件限制
    resetFileLimit: (params: { uniqueId: string; fileIds: string[] }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.resetFileLimit,
        data: params,
      }),
    //  获取解析百分比
    analysisPercentage: (params: { fileIds: string[] }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.analysisPercentage,
        data: params,
      }),
    // 保存合同内容
    updateContractQuestionAnswer: (params: API.updateContractQuestionAnswerParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateContractQuestionAnswer,
        data: params,
      }),
    // 记录法律文书实例访问接口
    showIndictmentExample: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.showIndictmentExample,
      }),
    // 合同生成模型普通回答接口
    sendGptMessageContractBasicAnswerStream: (
      params: API.SendGptMessageContractBasicAnswerStreamParams,
      config?: FetchEventSourceConfig,
    ) => sendSSERequest(url.sendGptMessageContractBasicAnswerStream, "POST", params, config),
    // 合同生成-复制
    selectAnswer: (params: { qaId: string }) =>
      sendRequest($axios, {
        method: "GET",
        url: url.selectAnswer,
        params,
      }),
    // 查询知识库详情信息
    queryKnowledgeInfo: (params: { type: string; typeId: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.queryKnowledgeInfo,
        data: params,
      }),
    sendGptMessageTraditionalPleadingsStream: (
      params: API.SendGptMessageTraditionalPleadingsStreamParams,
      config?: FetchEventSourceConfig,
    ) => sendSSERequest(url.sendGptMessageTraditionalPleadingsStream, "POST", params, config),
    createTraditionalIndictmentSession: () =>
      sendRequest($axios, {
        method: "POST",
        url: url.createTraditionalIndictmentSession,
      }),
    downloadTraditionalIndictmentAnswer: (params: API.DownloadTraditionalIndictmentAnswerParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.downloadTraditionalIndictmentAnswer,
        data: params,
      }),
    conversionIndictment: (params: API.ConversionIndictmentParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.conversionIndictment,
        data: params,
      }),

    // 保存合同主体审查记录
    saveBodyReviewRecord: (params: API.SaveBodyReviewRecordParams) =>
      sendRequest<number>($axios, {
        method: "POST",
        url: url.saveBodyReviewRecord,
        data: params,
      }),

    // 获取合同主体审查记录
    getBodyReviewRecord: (params: API.GetBodyReviewRecordParams) =>
      sendRequest<API.GetBodyReviewRecordResult>($axios, {
        method: "POST",
        url: url.getBodyReviewRecord,
        data: params,
      }),

    // 企业基本信息
    enterpriseBasicInfo: (params: API.EnterpriseBasicInfoParams) =>
      sendRequest<API.EnterpriseBasicInfoResult>($axios, {
        method: "POST",
        url: url.enterpriseBasicInfo,
        data: params,
      }),

    // 企业基本信息历史记录
    enterpriseBasicInfoHistory: (params: API.EnterpriseBasicInfoHistoryParams) =>
      sendRequest<API.EnterpriseBasicInfoHistoryResult>($axios, {
        method: "POST",
        url: url.enterpriseBasicInfoHistory,
        data: params,
      }),

    // 企业主体资信与合规审查
    enterpriseBodyInfo: (params: API.EnterpriseBodyInfoParams) =>
      sendRequest<API.EnterpriseBodyInfoResult>($axios, {
        method: "POST",
        url: url.enterpriseBodyInfo,
        data: params,
      }),

    // 企业主体信息历史记录
    contractBodyHistory: (params: API.ContractBodyHistoryParams) =>
      sendRequest<API.EnterpriseBodyInfoResult>($axios, {
        method: "POST",
        url: url.contractBodyHistory,
        data: params,
      }),

    // 获取审查方名称
    queryReviewPartyName: (params: API.QueryReviewPartyBNameParams) =>
      sendRequest<API.QueryReviewPartyNameResult>($axios, {
        method: "POST",
        url: url.queryReviewPartyBName,
        data: params,
      }),

    // 文件摘要
    fileAbstract: (fileId: string, signal: AbortSignal) =>
      sendRequest<string>($axios, {
        method: "GET",
        url: `${url.fileAbstract}/${fileId}`,
        signal,
      }),
    // 意图识别
    intentionIdentify: (params: API.IntentionIdentifyParams, signal: AbortSignal) =>
      sendRequest($axios, {
        method: "POST",
        url: url.intentionIdentify,
        data: params,
        signal,
      }),

    // 引导提问
    guideQuestion: (params: API.GuideQuestionParams) =>
      sendRequest<API.GuideQuestionResult>($axios, {
        method: "POST",
        url: url.guideQuestion,
        data: params,
      }),
    // 跳转页面
    jumpPage: (params: API.JumpPageParams) =>
      sendRequest<boolean>($axios, {
        method: "POST",
        url: url.jumpPage,
        data: params,
      }),
    //创建会话
    createAssistantSession: () =>
      sendRequest<string>($axios, {
        method: "POST",
        url: url.createAssistantSession,
      }),
    // 查询会话列表
    assistantSessionList: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.assistantSessionList,
      }),
    // 查询最新会话
    selectNewSessionV2: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.selectNewSessionV2,
      }),
    // 置顶对话记录
    toppingSession: (params: API.ToppingSessionParams) =>
      sendRequest<boolean>($axios, {
        method: "PUT",
        url: url.toppingSession,
        data: params,
      }),

    // 查询会话历史记录
    selectAiAssistantHistory: (params: API.SelectAiAssistantHistoryParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.selectAiAssistantHistory,
        data: params,
      }),
    questionClassify: (params: API.IntentionIdentifyParams, signal: AbortSignal) =>
      sendRequest($axios, {
        method: "POST",
        url: url.questionClassify,
        data: params,
        signal,
      }),
    // 匹配模板
    conversionIndictmentTemplate: (params: API.ConversionIndictmentTemplateParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.conversionIndictmentTemplate,
        data: params,
      }),
    // // 查询会话历史记录
    // selectAiAssistantHistoryV2: (params: API.SelectAiAssistantHistoryParams) =>
    //   sendRequest($axios, {
    //     method: "POST",
    //     url: url.selectAiAssistantHistoryV2,
    //     data: params,
    //   }),
    // // 查询会话列表
    // assistantSessionListV2: () =>
    //   sendRequest($axios, {
    //     method: "GET",
    //     url: url.assistantSessionListV2,
    //   }),
    // //创建会话
    // createAssistantSessionV2: () =>
    //   sendRequest<string>($axios, {
    //     method: "POST",
    //     url: url.createAssistantSessionV2,
    //   }),

    // 文本分析 编辑功能
    updateTextAnalysisAnswer: (params: API.UpdateTextAnalysisAnswerParams) =>
      sendRequest($axios, {
        method: "POST",
        url: url.updateTextAnalysisAnswer,
        data: params,
      }),

    // 自定义指令
    selectExample: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.selectExample,
      }),
    saveExample: (params: any) =>
      sendRequest($axios, {
        method: "POST",
        url: url.saveExample,
        data: params,
      }),
    deleteExample: (params: any) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.deleteExample + params.id,
      }),
    //法律研究示例
    studyExample: () =>
      sendRequest($axios, {
        method: "GET",
        url: url.studyExample,
      }),
    //法律研究示例SSE
    studyExampleSse: (params: any, config?: FetchEventSourceConfig) =>
      sendSSERequest(url.studyExampleSse, "POST", params, config),

    // 上传模板调用接口
    generateContractContentByTemplateSseStream: (
      params: API.SendGptMessageContractOutlineStreamParams,
      config?: FetchEventSourceConfig,
    ) => sendSSERequest(url.generateContractContentByTemplateSseStream, "POST", params, config),

    // ai对话、法律研究提示词优化
    studyQueryOptimize: (params: { query: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.studyQueryOptimize,
        data: params,
      }),
    // ai检索提示词优化
    aiSearchQueryOptimize: (params: { query: string }) =>
      sendRequest($axios, {
        method: "POST",
        url: url.aiSearchQueryOptimize,
        data: params,
      }),
    // 我的文档 - 删除文档（单个/批量）
    docDeleteDocument: (ids: API.DocDeleteDocumentParams) =>
      sendRequest($axios, {
        method: "DELETE",
        url: url.docDeleteDocument,
        data: ids,
      }),
    // 我的文档 - 创建文件夹
    docCreateFolder: (params: API.DocCreateFolderParams) =>
      sendRequest<API.DocCommonResult>($axios, {
        method: "POST",
        url: url.docCreateFolder,
        data: params,
      }),
    // 我的文档 - 移动文件/文件夹
    docMoveDocument: (params: API.DocMoveDocumentParams) =>
      sendRequest<API.DocCommonResult>($axios, {
        method: "POST",
        url: url.docMoveDocument,
        data: params,
      }),
    // 我的文档 - 查询文档树（GET，用于移动弹窗等选择目录）
    docQueryTree: () =>
      sendRequest<API.DocQueryTreeResult>($axios, {
        method: "GET",
        url: url.docQueryTree,
      }),
    // 我的文档 - 查询文档分页列表（含面包屑）
    docQueryList: (params: API.DocQueryListParams) =>
      sendRequest<API.DocQueryListResult>($axios, {
        method: "POST",
        url: url.docQueryList,
        data: params,
      }),
    // 我的文档 - 修改文件夹名称
    docModifyFolderName: (params: API.DocModifyFolderNameParams) =>
      sendRequest<boolean>($axios, {
        method: "POST",
        url: url.docModifyFolderName,
        data: params,
      }),
    // 我的文档 - 检索文档（分页，GET）
    docSearch: (params: API.DocSearchParams) =>
      sendRequest<API.DocSearchResult>($axios, {
        method: "GET",
        url: url.docSearch,
        params,
      }),
  };
};
